import { ActionType, AssetType, ChangeMediaOperationType, ChangeMediaType, ContentType, EventToolBarType, EventType, SenderType } from '@/const/mission';
import { IEvents } from '@/interface';

const EmptyMediaValue = {
  [ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
    spine: {},
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
    multiVerticalPainting: [],
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
    backgroundImage: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
    },
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
    foregroundImage: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
    },
  },
  [ChangeMediaType.REMOVE_FORE_IMAGE]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE,
    foregroundImage: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
    },
  },
  [ChangeMediaType.REMOVE_BG_IMAGE]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE,
    foregroundImage: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
    },
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_SOUND_EFFECT]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_BGM_AUDIO,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
    bgmAudio: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
      loopPlay: false,
    },
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_BGM_AUDIO]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_BGM_AUDIO,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
    bgmAudio: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
      loopPlay: true,
    },
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_PAUSE_BGM_AUDIO]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_BGM_AUDIO,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE,
    bgmAudio: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
    },
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_FULL_VIDEO]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_FULL_VIDEO,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
    fullVideo: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
    },
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_VIDEO]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_VIDEO,
    operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
    backgroundVideo: {
      url: { url: '' },
      sample: { primary: '', complementary: '' },
      showType: 1,
    },
  },
  [ChangeMediaType.CHANGE_MEDIA_TYPE_DEFAULT]: {
    type: ChangeMediaType.CHANGE_MEDIA_TYPE_DEFAULT,
  },
};

const eventDefaultValue: { [key: string]: IEvents } = {
  [EventToolBarType.ADD_SPINE_FORE_IMAGE]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE],
    },
  },
  [EventToolBarType.ADD_MULTI_CHARACTER]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER],
    },
  },
  [EventToolBarType.ADD_AUDIO]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_BGM_AUDIO],
    },
  },
  [EventToolBarType.ADD_SOUND_EFFECT]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_SOUND_EFFECT],
    },
  },
  [EventToolBarType.STOP_AUDIO]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_PAUSE_BGM_AUDIO],
    },
  },
  [EventToolBarType.ADD_VIDEO]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_FULL_VIDEO],
    },
  },
  [EventToolBarType.ADD_BG_VIDEO]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_VIDEO],
    },
  },
  [EventToolBarType.ADD_BG_IMAGE]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE],
    },
  },
  [EventToolBarType.REMOVE_BG_IMAGE]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.REMOVE_BG_IMAGE],
    },
  },
  [EventToolBarType.ADD_FORE_IMAGE]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE],
    },
  },
  [EventToolBarType.REMOVE_FORE_IMAGE]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_CHANGEMEDIA,
      changeMedia: EmptyMediaValue[ChangeMediaType.REMOVE_FORE_IMAGE],
    },
  },
  [EventToolBarType.ADD_BOT]: {
    type: EventType.EVENT_TYPE_MESSAGE,
    message: {
      type: ContentType.CONTENT_TYPE_TEXT,
      text: { text: '', showType: 0 },
      sender: {
        type: SenderType.BOT,
        senderId: '',
      },
    },
  },
  [EventToolBarType.ADD_SYSTEM]: {
    type: EventType.EVENT_TYPE_MESSAGE,
    message: {
      type: ContentType.CONTENT_TYPE_TEXT,
      text: { text: '', showType: 0 },
      sender: {
        type: SenderType.SYSTEM,
        senderId: '',
      },
    },
  },
  [EventToolBarType.ADD_PROPS]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_SHOWCARD,
      showAsset: {
        type: AssetType.ASSET_TYPE_ITEMSCARD,
        itemCard: {},
      },
    },
  },
  [EventToolBarType.ADD_DRAWER]: {
    type: EventType.EVENT_TYPE_EXCL,
  },
  [EventToolBarType.ADD_GUIDE_REPLAY]: {
    type: EventType.EVENT_TYPE_ACTION,
    action: {
      type: ActionType.ACTION_TYPE_GUIDEREPLY,
      guideReply: {
        options: [],
      },
    },
  },
};

export { EmptyMediaValue, eventDefaultValue };
